import axios from 'axios'

export default axios.create({
    baseURL: 'https://admin.ldbconstruction.com/api'
    // baseURL: 'https://admin.ldbconstruction.stageoptimal.co.za/api'
    // baseURL: 'http://127.0.0.1:8000/api',
})